module.exports = __webpack_public_path__ + "media/assets/BlueCircleX-36b2332191949ab68c926015794b1052.svg";